import React, { useContext } from "react"
import { CalendarContext } from "../context"
import { Create, Update, MultipleCreate } from "../CalendarModal"
import { WeChatCreate, WeChatUpdate, WeChatMultipleCreate } from "../WeChatModal"
import { WeiboCreate, WeiboUpdate, WeiboMultipleCreate, WeiboDraftCreate, WeiboDraftUpdate } from "../WeiBoModal"
import { ChildCreate, ChildUpdate } from "../ChildModal"
import { SpeciesCreate, SpeciesUpdate, SpeciesDraftCreate, SpeciesDraftUpdate } from "../SpeciesModal"
import { EatCreate, EatUpdate } from "../EatModal"
import { BeautyCreate, BeautyUpdate } from "../BeautyModal"
import { DraftCreate, DraftUpdate } from "Components/Calendar/DraftModal"
import { VideoCreate, VideoUpdate } from "Components/Calendar/VideoModal"
import { PhotoCreate, PhotoUpdate } from "Components/Calendar/PhotoModal"
import EatDraftCreate from "../EatModal/EatDraftCreate"
import EatDraftUpdate from "../EatModal/EatDraftUpdate"
import { HealthCreate, HealthDraftCreate, HealthDraftUpdate, HealthUpdate } from "../HealthModal"

export default function Index() {
    const { boardModifyDialog } = useContext(CalendarContext)
    if (boardModifyDialog) {
        switch (boardModifyDialog.type) {
            case "create":
                return <Create />
            case "update":
                return <Update />
            case "multiple_create":
                return <MultipleCreate />
            case "weibo_create":
                return <WeiboCreate />
            case "weibo_update":
                return <WeiboUpdate />
            case "weibo_multiple_create":
                return <WeiboMultipleCreate />
            case "weibo_draft_create":
                return <WeiboDraftCreate />
            case "weibo_draft_update":
                return <WeiboDraftUpdate />
            case "wechat_create":
                return <WeChatCreate />
            case "wechat_update":
                return <WeChatUpdate />
            case "wechat_multiple_create":
                return <WeChatMultipleCreate />
            case "child_create":
                return <ChildCreate />
            case "child_update":
                return <ChildUpdate />
            case "species_create":
                return <SpeciesCreate />
            case "species_update":
                return <SpeciesUpdate />
            case "eat_create":
                return <EatCreate />
            case "eat_update":
                return <EatUpdate />
            case "beauty_create":
                return <BeautyCreate />
            case "beauty_update":
                return <BeautyUpdate />
            case "draft_create":
                return <DraftCreate />
            case "draft_update":
                return <DraftUpdate />
            case "video_create":
                return <VideoCreate />
            case "video_update":
                return <VideoUpdate />
            case "photo_create":
                return <PhotoCreate />
            case "photo_update":
                return <PhotoUpdate />
            case "health_create":
                return <HealthCreate />
            case "health_update":
                return <HealthUpdate />
            case "species_draft_create":
                return <SpeciesDraftCreate />
            case "species_draft_update":
                return <SpeciesDraftUpdate />
            case 'eat_draft_create':
                return <EatDraftCreate />
            case 'eat_draft_update':
                return <EatDraftUpdate />
            case "health_draft_create":
                return <HealthDraftCreate />
            case "health_draft_update":
                return <HealthDraftUpdate />
            default:
                return null
        }
    } else {
        return null
    }
}
